<template>
  <div class="row">
    <div class="col col-12">
      <div class="tabs-container">
        <ul class="nav nav-tabs" id="nav-list" role="tablist">
          <li
            v-for="(language, key) in this.defaultLangs"
            class="nav-item"
            :key="'tab-' + key"
          >
            <a
              class="nav-link"
              :class="{ active: key === 0 }"
              :id="'langTab-' + key"
              data-toggle="tab"
              :href="'#langContent-' + key"
              role="tab"
              :aria-controls="'langContent-' + key"
              :aria-selected="key === 0 ? 'true' : 'false'"
            >
              {{ getTabName(language) }}
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div
            v-for="(language, key) in this.defaultLangs"
            v-bind:key="'content-' + key"
            class="tab-pane"
            :class="{ 'show active': key === 0 }"
            :id="'langContent-' + key"
            role="tabpanel"
            :aria-labelledby="'langTab-' + key"
          >
            <div class="panel-body">
              <lang
                :ref="'langForm' + key"
                class="py-2"
                :lang="filterData(language)"
                :availability="getAvailabilityRadioData(language)"
              >
              </lang>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Lang from './Forms/Lang.vue'
export default {
  name: 'VNFRProductLangs',
  props: {
    langs: {
      type: Array,
      required: true
    },
    loadingData: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      defaultLangs: [ 'pl', 'en', 'de', 'es', 'fr', 'it' ],
      valid: []
    }
  },
  created() {
    if ( this.langs.length < 1 ) {
      this.prepareDefaultLanguages()
    }
  },
  watch: {
    'loadingData'( newValue ) {
      if ( newValue === true ){
        this.$emit( 'loading', true )
      } else {
        this.$emit( 'loading', false )
      }
    }
  },
  methods: {
    filterData( lang ) {
      const data = this.langs.filter( language => language.lang === lang )
      if ( data.length > 0 ) {
        return data[ 0 ]
      } else {
        const defaultLang = this.getDefaultLang()
        defaultLang.lang = lang
        this.langs.push( defaultLang )
        return this.filterData( lang )
      }
    },
    getDefaultLang() {
      return {
        id: null,
        lang: '',
        name: '',
        visible: 0,
        name_prefix: '',
        name_suffix: '',
        description: '',
        application: '',
        composition: ''
      }
    },
    prepareDefaultLanguages() {
      this.defaultLangs.forEach( value => {
        this.addDefaultLang( value )
      } )
    },
    addDefaultLang( lang ) {
      const defaultLang = this.getDefaultLang()
      defaultLang.lang = lang
      this.langs.push( defaultLang )
    },
    getAvailabilityRadioData( lang ) {
      const data = []
      switch ( lang ) {
        case 'pl':
          data.push(
            {
              key: 'od_ręki',
              name: 'Od ręki'
            },
            {
              key: 'chwilowy_brak_towaru',
              name: 'Chwilowy brak towaru'
            }
          )
          break
        case 'en':
          data.push(
            {
              key: 'right_away',
              name: 'Right away (Od ręki)'
            },
            {
              key: 'temporary_unavailable',
              name: 'Temporary unavailable (Chwilowy brak towaru)'
            }
          )
          break
        case 'de':
          data.push(
            {
              key: 'sofort',
              name: 'Sofort (Od ręki)'
            },
            {
              key: 'vorübergehender_warenmangel',
              name: 'Vorübergehender warenmangel (Chwilowy brak towaru)'
            }
          )
          break
        case 'fr':
          data.push(
            {
              key: 'en_stock',
              name: 'En stock (Od ręki)'
            },
            {
              key: 'en_rupture_de_stock_temporaire',
              name: 'En rupture de stock temporaire (Chwilowy brak towaru)'
            }
          )
          break
        case 'es':
          data.push(
            {
              key: 'de_inmediato',
              name: 'De inmediato (Od ręki)'
            },
            {
              key: 'falta_temporal_de_producto',
              name: 'Falta temporal de producto (Chwilowy brak towaru)'
            }
          )
          break
        case 'it':
          data.push(
            {
              key: 'subito',
              name: 'Subito (Od ręki)'
            },
            {
              key: 'temporanea_mancanza_di_merce',
              name: 'Temporanea mancanza di merce (Chwilowy brak towaru)'
            }
          )
          break
        default:
          data.push(
            {
              key: 'right_away',
              name: 'Right away (Od ręki)'
            },
            {
              key: 'temporary_unavailable',
              name: 'Temporary unavailable (Chwilowy brak towaru)'
            }
          )
      }
      return data
    },
    getTabName( lang ) {
      let tabName = ''
      switch ( lang ) {
        case 'pl':
          tabName = 'Polski'
          break
        case 'en':
          tabName = 'Angielski'
          break
        case 'de':
          tabName = 'Niemiecki'
          break
        case 'fr':
          tabName = 'Francuski'
          break
        case 'es':
          tabName = 'Hiszpański'
          break
        case 'it':
          tabName = 'Włoski'
          break
        default:
          tabName = 'Nieznany jezyk'
      }
      return tabName
    },
    validationForms() {
      const promiseList = []
      this.defaultLangs.forEach( ( lang, index ) => {
        promiseList.push( this.validForm( `langForm${  index}` ) )
      } )
      return Promise.all( promiseList ).then( value => {
        let valid = true
        value.forEach( ( element, key ) => {
          if ( element === false ){
            /* eslint-disable */
            $( `#langTab-${ key }` ).click()
            /* eslint-enable */
            valid = false
            return
          }
        } )
        return valid
        } )
    },
    validForm( formName ) {
     return this.$refs.[ formName ][ 0 ].$validator.validateAll().then( result => result )
    }
  },
  components: {
    Lang
  }
}
</script>
